import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableHead: {
    backgroundColor: "#005598",
    color: "white",
    textAlign: "center",
  },
  tablecell: {
    boxShadow:
      "0px 0px 1px 0 #ccc, 0px 1px 0px 0px lightgrey, 0px 1px 1px 0px rgba(0,0,0,0)",
    padding: "8px",
    color: "black",
    textAlign: "center",
  },
  tablefirstcell: {
    boxShadow:
      "0px 0px 1px 0 #ccc, 0px 1px 0px 0px lightgrey, 0px 1px 1px 0px rgba(0,0,0,0)",
    padding: "8px",
    color: "white",
    textAlign: "center",
  },
  tablelastcell: {
    boxShadow:
      "0px 0px 1px 0 #ccc, 0px 1px 1px 0px lightgrey, 0px 1px 1px 0px rgba(0,0,0,0)",
  },
}));

const CheckList = (checkList) => {
  const classes = useStyles();

  const columns = [
    { index: 1, label: "Application Item", static: true },
    { index: 2, label: "Completed", field: "completed" },
    { index: 3, label: "Completion Date", field: "completionDate" },
    { index: 4, label: "Notes", field: "notes" },
  ];
  return (
    <>
      <TableContainer component={Paper}>
        <Table style={{ borderCollapse: "collapse", width: "100%" }}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.field}
                  className={classes.tablefirstcell}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.tablecell}>Passport</TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_passport}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_passportreceiveddate != null
                  ? moment(checkList.data.ses_passportreceiveddate).format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </TableCell>
              <TableCell className={classes.tablelastcell}>
                {checkList.data.ses_passportnotes}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tablecell}>Resume</TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_resume}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_resumereceiveddate != null
                  ? moment(checkList.data.ses_resumereceiveddate).format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </TableCell>
              <TableCell className={classes.tablelastcell}>
                {checkList.data.ses_resumenotes}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tablecell}>Portfolio</TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_portfolio}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_portfolioreceiveddate != null
                  ? moment(checkList.data.ses_portfolioreceiveddate).format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </TableCell>
              <TableCell className={classes.tablelastcell}>
                {checkList.data.ses_portfolionotes}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tablecell}>Interview</TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_interview}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_interviewcompleteddate != null
                  ? moment(checkList.data.ses_interviewcompleteddate).format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </TableCell>
              <TableCell className={classes.tablelastcell}>
                {checkList.data.ses_interviewnotes}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tablecell}>Written Easy</TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_writtenessay}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_writtenessayreceiveddate != null
                  ? moment(checkList.data.ses_writtenessayreceiveddate).format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </TableCell>
              <TableCell className={classes.tablelastcell}>
                {checkList.data.ses_writtenessaynotes}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tablecell}>Transcripts</TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_transcripts}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_transcriptsreceiveddate != null
                  ? moment(checkList.data.ses_transcriptsreceiveddate).format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </TableCell>
              <TableCell className={classes.tablelastcell}>
                {checkList.data.ses_transcriptnotes}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tablecell}>Aid Form</TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_aidform}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {checkList.data.ses_aidformreceiveddate != null
                  ? moment(checkList.data.ses_aidformreceiveddate).format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </TableCell>
              <TableCell className={classes.tablelastcell}>
                {checkList.data.ses_aidformnotes}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
export default CheckList;
